import { config } from "@lib/config"

import { BaseHttpProvider } from "./base-http.provider"

export class InappPurchasesProvider extends BaseHttpProvider {
  async find() {
    const response = await this.execute({
      uri: "/inapp-purchases?_locale=ru",
      method: "GET",
    })

    return response
  }

  async getBundles(bundleNames: string[]) {
    const apiKey = config.data.pureApiKey
    const response = await this.execute({
      uri: `/purchases/bundles/?name=${bundleNames.join(",")}&apiKey=${apiKey}`,
      method: "GET",
      api: "pure",
    })

    return response
  }

  async getPaymentUrl(bundleName: string, userId: string, backUrl?: string) {
    const apiKey = config.data.pureApiKey
    const response = await this.execute({
      uri: "/purchases/order/cardpay/",
      method: "POST",
      api: "pure",
      data: {
        userId: userId,
        apiKey,
        bundleName,
        backUrl,
      },
    })

    return response
  }
}
